import React from 'react';
import { Navigate } from 'react-router-dom';
import {getFromSession} from "./util"
import { useProductVariant } from "../hooks/use-product-variant"
export const PrivateRoute = ({ component: Component, ...rest }) =>{
  return getFromSession('token') ? (
    <Component {...rest} />
  ) : (
    <Navigate
      to={{ pathname: '/login', state: { from: rest.location } }}
    />
  )
}

export const ProtectedRoute = ({ component: Component, requiredFeature, ...rest }) =>{

  const fromSession = getFromSession('token');
  const { hasFeature } = useProductVariant(fromSession);

  return fromSession ? (
    (hasFeature([requiredFeature], 'features') ? (
      <Component {...rest} />
    ) :(
      <Navigate to="/" replace />
    ))
  ) : (
    <Navigate
      to={{ pathname: '/login', state: { from: rest.location } }}
    />
  )
}